export default `
You see this page because either your system does not support Universal Links or during the installation it failed to set up correctly.  
To unlock the desired functionality you can still open the Code page in your app and enter the following code:    

<code>{code}</code>
`;
